import api from "../api/axios";
import ENDPOINTS from "../api/endpoints";

const multipartConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const getAllServices = async () => {
  const response = await api.get(ENDPOINTS.SERVICES.ALL);
  return response.data;
};

export const getServices = getAllServices;
export const fetchServices = getAllServices;

export const getServiceById = async (id) => {
  const response = await api.get(ENDPOINTS.SERVICES.BY_ID(id));
  return response.data;
};

export const getServiceByName = async (name) => {
  const response = await api.get(ENDPOINTS.SERVICES.BY_NAME, {
    params: { name },
  });
  return response.data;
};

export const getServiceTypes = async () => {
  const response = await api.get(ENDPOINTS.SERVICES.TYPES);
  return response.data;
};

export const getServiceWithBookings = async (id) => {
  const response = await api.get(ENDPOINTS.SERVICES.WITH_BOOKINGS(id));
  return response.data;
};

export const getServiceWithBookingDetails = getServiceWithBookings;
export const getServiceBookings = getServiceWithBookings;

export const getServiceWithBookingsByName = async (name) => {
  const response = await api.get(ENDPOINTS.SERVICES.WITH_BOOKINGS_BY_NAME, {
    params: { name },
  });
  return response.data;
};

export const createService = async (formData) => {
  const response = await api.post(
    ENDPOINTS.SERVICES.CREATE,
    formData,
    multipartConfig
  );
  return response.data;
};

export const addService = createService;

export const updateService = async (id, formData) => {
  const response = await api.put(
    ENDPOINTS.SERVICES.UPDATE(id),
    formData,
    multipartConfig
  );
  return response.data;
};

export const editService = updateService;

export const deleteService = async (id) => {
  const response = await api.delete(ENDPOINTS.SERVICES.DELETE(id));
  return response.data;
};

export const removeService = deleteService;

const serviceService = {
  getAllServices,
  getServices,
  fetchServices,
  getServiceById,
  getServiceByName,
  getServiceTypes,
  getServiceWithBookings,
  getServiceWithBookingDetails,
  getServiceBookings,
  getServiceWithBookingsByName,
  createService,
  addService,
  updateService,
  editService,
  deleteService,
  removeService,
};

export default serviceService;